import { FC, useMemo } from "react";
import { sanitizeUrl } from "@helpers";
import TileSubTitle from "./TileSubTitle";
import { iReportProPublication } from "@models/ReportProPublication";
import './ReportProTile.style.scss';
import cn from "classnames";
import { AppId, usePlatformContext } from "@datassential/platform-ui-lib";

export enum ReportProTileOption {
    Regular = '',
    Wide = 'wide',
    DynamicHeight = 'dyn-h',
    SmallTitle = 'title-s',
}

const ReportProTile: FC<{
    data?: iReportProPublication;
    options?: ReportProTileOption[];
    testId?: string;
}> = (
    {
        data,
        options,
        testId,
    }
) => {
    const { userInfo: { products} } = usePlatformContext();

    const reportPro = useMemo(
        () => products[AppId.ReportPro],
        [products]
    );

    if (data) {
        return (
            <a
                key={data.id}
                target="_blank"
                rel="noreferrer"
                href={sanitizeUrl(`${reportPro?.url}/details/${data.id}`)}
                className={cn(
                    "ReportProTile",
                    !!options && options.map(option => `is-${option}`),
                )}
                data-testid={testId}
            >
                <img src={data.thumbnail} alt="" className="ReportProTile__img"/>
                <div className="ReportProTile__content">
                    <div className="ReportProTile__title">
                        {data.title}
                    </div>
                    <TileSubTitle data={data}/>
                    <div className="ReportProTile__description">
                        {data.description}
                    </div>
                </div>
            </a>
        );
    }

    return (
        <div className="ReportProTile"/>
    );
};

export default ReportProTile;